module.exports = __webpack_public_path__ + "static/media/NoOrderHistory.6335d99c.svg";